module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "login"
  }, [_c('navbar'), _vm._v(" "), _c('p'), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "width": "20rem"
    }
  }, [_c('div', {
    staticClass: "card-block"
  }, [_c('h4', {
    staticClass: "card-title"
  }, [_vm._v("Please sign in")]), _vm._v(" "), _c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "inputEmail"
    }
  }, [_vm._v("Email address")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.username),
      expression: "credentials.username"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "id": "inputEmail",
      "placeholder": "Email address",
      "required": "",
      "autofocus": ""
    },
    domProps: {
      "value": (_vm.credentials.username)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "username", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "sr-only",
    attrs: {
      "for": "inputPassword"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.credentials.password),
      expression: "credentials.password"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "password",
      "id": "inputPassword",
      "placeholder": "Password",
      "required": ""
    },
    domProps: {
      "value": (_vm.credentials.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.credentials, "password", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.Remember),
      expression: "Remember"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "checkbox",
      "id": "rememberpassword"
    },
    domProps: {
      "checked": Array.isArray(_vm.Remember) ? _vm._i(_vm.Remember, null) > -1 : (_vm.Remember)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.Remember,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.Remember = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.Remember = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.Remember = $$c
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "rememberpassword"
    }
  }, [_vm._v("Remember password")]), _vm._v(" "), _c('div', [(_vm.loginfailed) ? _c('b-alert', {
    attrs: {
      "variant": "danger",
      "show": ""
    }
  }, [_vm._v("Login failed")]) : _vm._e()], 1), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": function($event) {
        _vm.login()
      }
    }
  }, [_vm._v("Sign in")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0619388f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/login.vue
// module id = 240
// module chunks = 1